import React from 'react';

export default function ZealLogo({ fill = 'white' }: { fill?: string }) {
	return (
		<svg
			width="26"
			height="18"
			viewBox="0 0 26 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M20.3698 12.7958C20.028 15.4475 17.7661 17.4964 15.0263 17.4964C13.9827 17.4964 13.0081 17.1988 12.1831 16.6842C15.1245 18.5725 19.0581 18.4721 21.9312 16.1594C25.171 13.5524 25.3396 9.71078 24.1078 6.04475C23.6069 4.55515 23.3369 3.05742 24.6932 1.96445C24.7074 1.95361 24.723 1.94072 24.7386 1.93123C25.0919 1.65731 25.9013 1.40034 25.9013 1.40034C25.1595 1.48374 24.3974 1.27423 23.8012 0.786741C22.2086 -0.499455 19.8513 -0.146887 18.6188 1.47764L18.6175 1.47899C18.5925 1.51289 18.5688 1.54747 18.5451 1.58273C17.5238 3.09199 17.8168 5.11384 19.1501 6.35461L19.165 6.36952C18.0693 5.34233 16.5498 4.745 14.9018 4.745H0.0986328C0.521639 5.47861 1.01774 5.94644 1.67628 6.24273C2.39099 6.56411 3.31686 6.70175 4.77133 6.70175H15.2619C16.7915 6.78243 18.3671 7.52893 19.36 8.89174C20.1687 10.001 20.5403 11.2546 20.367 12.8005L20.3698 12.7958Z"
				fill={fill}
			/>
			<path
				d="M18.9788 11.4845C18.8211 11.214 18.6357 10.9699 18.4218 10.7543C17.632 9.95694 16.4936 9.55284 15.0364 9.55284H6.97089C5.54485 9.55284 4.64334 9.42063 3.95435 9.11077C3.41831 8.87008 3.00478 8.51548 2.64404 7.9812H14.9918C16.6689 7.9812 17.6442 8.84635 18.1673 9.57182C18.5612 10.1169 18.8387 10.7794 18.9788 11.4845Z"
				fill={fill}
			/>
			<path
				d="M17.9817 12.9582C17.3692 12.6334 16.4447 12.6334 15.0349 12.6334H9.66376C8.23772 12.6334 7.33621 12.5012 6.64722 12.1913C6.11119 11.9506 5.69765 11.596 5.33691 11.0618H15.1696C16.6193 11.0618 17.3618 11.8666 17.6758 12.3466C17.8017 12.5378 17.9053 12.746 17.9817 12.9582Z"
				fill={fill}
			/>
			<path
				d="M12.3602 15.7154C10.9335 15.7154 10.032 15.5832 9.3437 15.2734C9.02424 15.1296 8.74946 14.9452 8.50513 14.7093C8.33525 14.5465 8.17958 14.3601 8.03271 14.1438H15.3436C16.1382 14.1438 16.8089 14.3797 17.3416 14.8449C17.1358 15.0178 16.9091 15.1588 16.6539 15.2734C15.9663 15.5832 15.0641 15.7154 13.6374 15.7154H12.3602Z"
				fill={fill}
			/>
		</svg>
	);
}
